export const CLOSABLE_BANNER_STORAGE = {
  STATE_KEY: 'closableBanners:v0',
} as const
